"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInteractionExtraData = void 0;
/**
 * When interactions are sent to us, we just get a simple `interactionData`
 * object, but some of it is stored in columns, some of it is stored as JSON.
 * This just separates the two.
 */
function getInteractionExtraData(verb, interactionData) {
    if (verb === 'attended') {
        var extraData = __assign({}, interactionData);
        delete extraData.attendanceType;
        return {
            mainData: {
                attendanceType: interactionData.attendanceType
            },
            extraData: extraData
        };
    }
    if (verb === 'RSVPed') {
        var extraData = __assign({}, interactionData);
        delete extraData.rsvpStatus;
        return {
            mainData: {
                rsvpStatus: interactionData.rsvpStatus
            },
            extraData: extraData
        };
    }
    return {
        mainData: {},
        extraData: {}
    };
}
exports.getInteractionExtraData = getInteractionExtraData;
